import cookies from 'js-cookie';
import { AccountType } from '@/common/constants';
import { toThousands } from '@/utils/money';
import { translation } from '@/plugins/i18n';

export const ZOOM_CSRF_TOKEN = 'ZOOM-CSRFTOKEN';

/**
 *
 * @param {*} url
 * @param {*} method
 * @param {*} data
 */
export const formJump = (url, method = 'POST', data = null) => {
  const form = document.createElement('form');
  form.action = url;
  form.method = method;
  form.id = 'jump_form';
  form.class = 'hidden_element';
  if (data) {
    for (let key in data) {
      if (data[key] === undefined) {
        continue;
      }
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = data[key];
      form.appendChild(input);
    }

    const input = document.getElementsByName(ZOOM_CSRF_TOKEN);
    if (input.length !== 0) {
      form.appendChild(input[0]);
    }
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

export const $cookie = cookies.withConverter({
  write: function (value) {
      return value;
  },
  read: cookies.converter.read,
});

export const isPaidAccount = (accountType) => {
  // exclude net new/free w/wo cc
  return [
    AccountType.ACCOUNT_UNKNOWN,
    AccountType.ACCOUNT_FREE_WITH_CC,
    AccountType.ACCOUNT_FREE_WITHOUT_CC
  ].includes(accountType) === false;
}

export const capitalizeFirstLetter = (string = '') => {
  if (typeof string !== 'string') return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const capacityFormatter = (capacity) => {
  const unitMap = {
    1000000: translation('billing.event_services.unit.million_1_uppercase')
  };
  return unitMap?.[capacity] || toThousands(capacity);
}

export const toLowercaseString = (str) => {
  return str?.toLowerCase?.() ?? str;
}

export const toUpCaseString = (str) => {
  return str?.toUpperCase?.() ?? str;
}

export const stripHTML = (htmlStr) => {
  const div = document.createElement('div');
  div.innerHTML = htmlStr;
  return div.textContent || div.innerText || '';
}

export const deduplicate = arr => [...new Set(arr)];
